module.exports = __webpack_public_path__ + "img/advertising.01e4b678.png";